// extracted by mini-css-extract-plugin
module.exports = {"whatsappScreen":"_3wTO_","cardWrapper":"_3pO1N","openWhatsappButton":"_2jCWF","externalIcon":"_6JmzM"};